import httpClient from './httpClient';

const base = '/api/compras-docentes';

export const listarCompras  = (params = {}) => {
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v))
  ).toString();
  return httpClient.get(qs ? `${base}?${qs}` : base);
};

export const crearCompra             = (datos) => httpClient.post(base, datos);
export const registrarEnContifico    = (id)    => httpClient.post(`${base}/${id}/registrar-contifico`);
